import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const brandBasicDetailsStyles = {
    '& .MuiStack-root > *:not(style) ~ *:not(style)': {
        marginTop: '0 !important',
    },
    '& .basic-details__logo': {
        marginBottom: '40px',
        maxWidth: 'max-content',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            marginBottom: 0,
            padding: '20px 0',
        },
    },
    '& .details-sample-list .MuiStack-root.ra-field': {
        padding: '20px 0 !important',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            padding: '20px 0 16px 0 !important',
        },
        '& .RaLabeled-label': {
            width: '220px !important',
            minWidth: '220px !important',
            lineHeight: '20px !important',
            color: `${Palette.black} !important`,
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                width: '100% !important',
                minWidth: '100% !important',
                marginBottom: '-2px',
            },
        },
        '& .MuiTypography-root.MuiTypography-body2, & .MuiTypography-root.MuiTypography-caption': {
            fontWeight: '600 !important',
        },
    },
};
